import { Field, RichTextField, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  KeyValuePair,
  DynamicPlaceholderParams,
  TranslationOptionsParams,
  AnchorTargetParams,
  RenderingProps,
} from '@/shared/shared.types';

export type C31IconCTABorderedCardProps = RenderingProps<
  C30IconCTABorderedCardFields,
  C30IconCTABorderedCardParams
>;

export type C30IconCTABorderedCardFields = {
  Icon?: KeyValuePair;
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  FirstCTA?: LinkField;
  SecondCTA?: LinkField;
};

export type C30IconCTABorderedCardParams = {
  HeadlineTag?: string;
  TopBorderColor?: string;
  FirstCTAStyle?: string;
  SecondCTAStyle?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;
